<template>
  <div>
    <el-descriptions :column="1" :colon="false" v-for="(item,i) in complaintList" :key="i">
      <el-descriptions-item>
        <el-progress :percentage="100" :show-text="false">sss</el-progress>
        <el-divider class="divider"></el-divider>
      </el-descriptions-item>
      <el-descriptions-item :labelStyle="descriptionsItemStyle" :contentStyle="descriptionsItemStyle">
        <template slot="label">
          <i class="el-icon-time" style="font-size: 20px;font-weight:500;color: #157efb"></i>
        </template>
        {{ item.time }}
      </el-descriptions-item>
      <el-descriptions-item :labelStyle="descriptionsItemStyle" :contentStyle="descriptionsItemStyle">
        <template slot="label">
          类型：
        </template>
        {{ item.type === '1' ? '投诉':'建议' }}
      </el-descriptions-item>
      <el-descriptions-item :labelStyle="descriptionsItemStyle" :contentStyle="descriptionsItemStyle">
        <template slot="label">
          所选门店：
        </template>
        {{ item.storeName }}
      </el-descriptions-item>
      <el-descriptions-item v-if="item.type === '1'" :labelStyle="descriptionsItemStyle" :contentStyle="descriptionsItemStyle">
        <template slot="label">
          所选区域：
        </template>
        {{ item.region }}
      </el-descriptions-item>
      <el-descriptions-item v-if="item.type === '1'" :labelStyle="descriptionsItemStyle" :contentStyle="descriptionsItemStyle">
        <template slot="label">
          投诉内容：
        </template>
        {{ item.matters }}
      </el-descriptions-item>
      <el-descriptions-item v-if="item.type === '0'" :labelStyle="descriptionsItemStyle" :contentStyle="descriptionsItemStyle">
        <template slot="label">
          建议：
        </template>
        {{ item.suggestion }}
      </el-descriptions-item>
      <el-descriptions-item v-for="(image,j) in item.images" :key="j">
        <el-image style="width: 300px; height: 300px; border:none;cursor: pointer;"
                  :src="getImage(image.imageName)"
                  :preview-src-list="[`${baseURL}/download?name=${image.imageName}`]"
        >
        </el-image>
      </el-descriptions-item>
      <el-descriptions-item>
        <el-divider></el-divider>
      </el-descriptions-item>
      <el-descriptions-item label="处理结果：" :labelStyle="descriptionsItemStyle" :contentStyle="descriptionsItemStyle">
        <i v-if="item.isHandle" class="iconfont icon-yichuli" style="color:#009b4c"></i>
        <i v-if="!item.isHandle" class="iconfont icon-weichuli" style="color:#f56c6c"></i>
      </el-descriptions-item>
      <el-descriptions-item label="回复时间：" :labelStyle="descriptionsItemStyle" :contentStyle="descriptionsItemStyle">
        {{ item.handleTime }}
      </el-descriptions-item>
      <el-descriptions-item label="" :labelStyle="replyLabelStyle" :contentStyle="replyContentStyle">
        {{ item.replyResult }}
      </el-descriptions-item>
    </el-descriptions>
<!--    <p v-if="loading" v-loading="loading"-->
<!--       element-loading-text="拼命加载中"-->
<!--       element-loading-spinner="el-icon-loading"-->
<!--       element-loading-background="rgba(0, 0, 0, 0.8)"></p>-->
<!--    <p v-if="finished" style="text-align: center">没有更多了...</p>-->
  </div >
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      baseURL: this.$http.defaults.baseURL,
      descriptionsItemStyle: {
        height: "auto",
        fontSize: "15px",
        alignItems: "center",
        marginLeft: '2px',
        fontFamily: '华文中宋',
      },
      replyLabelStyle: {
        fontSize: "18px",
      },
      replyContentStyle: {
        backgroundColor: "#f3f3f3",
        fontSize: "18px",
        borderRadius: "10px",
        fontFamily: '新宋体'
      },
      complaintList: [],
      page: 1,
      pageSize: 5,
      loading: false,
      finished: false,
    }
  },
  created() {
    this.getComplaintInfo()
    window.addEventListener('scroll', this.handleScroll,true);
  },
  computed: {
    disabled() {
      return this.loading || this.finished
    }
  },
  methods: {
    async getComplaintInfo() {
      this.loading = true
      const res = await this.$http.get(`/complaint/${this.page}/${this.pageSize}`)
      if (String(res.code === '1')) {
        if (res.data.records.length > 0) {
          this.complaintList = this.complaintList.concat(res.data.records)
          this.loading = false
          if (res.data.records.length < this.pageSize) {
            this.loading = false
            this.finished = true
          }
        } else {
          this.loading = false
          this.finished = true
        }
      }
      this.loading = false
    },
    goComplaint() {
      this.$router.push('/complaintForm');
    },
    goSuggestion() {
      this.$router.push('/suggestionForm');
    },
    getImage(image) {
      return `${this.baseURL}/download?name=${image}`
    },
    load() {
      this.loading = true
      // this.$message.success("滚动条触发")
      if (this.finished == false) {
        this.page++
        this.getComplaintInfo()
      }else{
        this.loading = false
      }
    },
    handleScroll(){
      this.load()
    }
  },
}
</script>

<style>
.el-container {
  height: 100%;
  background: #fff;
}

.el-header, .el-footer {
  background: #fff;
  text-align: center;
}

.el-footer {
line-height: 100px;
}

.el-main {
  padding: 0 20px;
  background: #fff;
}

.el-descriptions-item__cell {
  padding: 0 12px;
}

.el-divider {
  margin: 0;

}

.divider{
  background-color: #157EFB;
  height: 5px;
  border-radius: 5px;
}

.el-descriptions-item__label:not(.is-bordered-label) {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/announcementPlatform.vue